module.exports = "/_next/static/images/e82dc9f549cdbe62de8ec23cca446cd6-group-man-building@0.75x.jpg";